import { initSlider } from './slider.js';
import { initThreeScene } from './threeScene.js';

const canvas = document.querySelector('canvas.webgl');
if (canvas) {
    initThreeScene({ particlesCount: 300 });
}
initSlider();

const menuToggle = document.querySelector('.menu-toggle');
const nav = document.querySelector('header nav');

if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
        nav.classList.toggle('open');
    });
}

const contactForm = document.getElementById('contact-form');
if (contactForm) {
    contactForm.addEventListener('submit', function (event) {
        event.preventDefault();
        emailjs.sendForm('service_hph5smv', 'template_2612j22', this)
            .then(() => {
                // Muestra confirmación
                const aviso = document.createElement('p');
                aviso.textContent = '¡Tu mensaje fue enviado con éxito!';
                aviso.classList.add('form-success'); // opcional: para estilos
                contactForm.appendChild(aviso);

                contactForm.reset();
            })
            .catch((err) => {
                const aviso = document.createElement('p');
                aviso.textContent = 'Hubo un problema al enviar el mensaje.';
                aviso.classList.add('form-error');
                contactForm.appendChild(aviso);

                console.error('Error al enviar el formulario:', err);
            });
    });
}

const applicationForm = document.getElementById('job-application-form');
if (applicationForm) {
    applicationForm.addEventListener('submit', function (event) {
        event.preventDefault();

        const getValue = (name) => this.elements[name]?.value?.trim() ?? '';
        const timestamp = new Date().toISOString();
        const vacancy = 'Desarrollador Training (Prácticas) – React + Node.js';

        const messageLines = [
            `Vacante: ${vacancy}`,
            `Timestamp: ${timestamp}`,
            `Nombre completo: ${getValue('nombre')}`,
            `Email: ${getValue('email')}`,
            `Teléfono / WhatsApp: ${getValue('telefono') || 'No proporcionado'}`,
            `Ciudad / País: ${getValue('ubicacion') || 'No proporcionado'}`,
            `LinkedIn/Portafolio: ${getValue('linkedin') || 'No proporcionado'}`,
            `GitHub: ${getValue('github') || 'No proporcionado'}`,
            `Disponibilidad: ${getValue('disponibilidad')}`
        ];

        this.elements.vacante.value = vacancy;
        this.elements.timestamp.value = timestamp;
        this.elements.subject.value = `[Postulación] Dev Training – ${getValue('nombre') || 'Candidato'}`;
        this.elements.mensaje.value = messageLines.join('\n');

        emailjs.sendForm('service_hph5smv', 'template_2612j22', this)
            .then(() => {
                const aviso = document.createElement('p');
                aviso.textContent = '¡Tu postulación fue enviada con éxito!';
                aviso.classList.add('form-success');
                applicationForm.appendChild(aviso);

                applicationForm.reset();
            })
            .catch((err) => {
                const aviso = document.createElement('p');
                aviso.textContent = 'Hubo un problema al enviar la postulación.';
                aviso.classList.add('form-error');
                applicationForm.appendChild(aviso);

                console.error('Error al enviar el formulario:', err);
            });
    });
}
